import { render, staticRenderFns } from "./DiagnoseForm.vue?vue&type=template&id=4ab10421&scoped=true&lang=pug"
import script from "./DiagnoseForm.vue?vue&type=script&lang=js"
export * from "./DiagnoseForm.vue?vue&type=script&lang=js"
import style0 from "./DiagnoseForm.vue?vue&type=style&index=0&id=4ab10421&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab10421",
  null
  
)

export default component.exports